import { useState, useEffect } from 'react';

export const useNotificationPreferences = () => {
  const [notifications, setNotifications] = useState({
    content: {
      newFlyer: true,
      savedSearch: true,
      upcoming: true,
    },
    delivery: {
      email: true,
      push: true,
    },
  });

  useEffect(() => {
    const notificationPreferences = localStorage.getItem('notificationPreferences');
    if (notificationPreferences) {
      setNotifications(JSON.parse(notificationPreferences));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('notificationPreferences', JSON.stringify(notifications));
  }, [notifications]);

  const isNewFlyersEnabled = () => notifications.content.newFlyer;
  const isSavedSearchEnabled = () => notifications.content.savedSearch;
  const isUpcomingSavedFlyersEnabled = () => notifications.content.upcoming;

  return {
    notifications,
    setNotifications,
    isNewFlyersEnabled,
    isSavedSearchEnabled,
    isUpcomingSavedFlyersEnabled,
  };
};
